// Admin API key (x-api-key) for the backend's write/admin endpoints.
// Entered once by the admin and kept in localStorage; axiosConfig.js attaches
// it to every request. Never bundle the key itself into the frontend build.
const STORAGE_KEY = 'adminApiKey'

export const getAdminApiKey = () => localStorage.getItem(STORAGE_KEY) || ''

export const ensureAdminApiKey = () => {
  let key = getAdminApiKey()
  if (!key) {
    key = (window.prompt('Enter the admin API key (x-api-key):') || '').trim()
    if (key) localStorage.setItem(STORAGE_KEY, key)
  }
  return key
}

export const clearAdminApiKey = () => localStorage.removeItem(STORAGE_KEY)
